/*
 * @Author: wsx
 * @Date: 2022-01-21 15:01:41
 * @LastEditTime: 2022-01-21 15:02:49
 * @LastEditors: your name
 * @Description: 广播
 */
import { request } from "../utils/request";

class Broadcast {
  /**
   * @Description: 开始广播
   * 入参
   * {
      @param {String} broadcastServerId 广播服务编号 NOT  NULL
      @param {String} broadcastServerName 服务名称
      @param {String} otherServerId 服务第三方编号
      @param {String} broadcastServerBrand 广播服务品牌
      @param {String} broadcastServerIp 广播服务IP
      @param {String} broadcastServerPort 广播服务端口
      @param {String} broadcastServerUser 广播服务用户
      @param {String} broadcastServerPsw 广播服务密码
    * }
    */
  broadcastInit(reqBody) {
    return new Promise((resolve, reject) => {
      request("Broadcast.Init", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
       * @Description: 开始广播
       * {
          @param {String} broadcastServerId 广播服务编号 NOT  NULL
          @param {String} broadcastServerName 服务名称
          @param {String} otherServerId 服务第三方编号
          @param {String} broadcastServerBrand 广播服务品牌
          @param {String} broadcastServerIp 广播服务IP
          @param {String} broadcastServerPort 广播服务端口
          @param {String} broadcastServerUser 广播服务用户
          @param {String} broadcastServerPsw 广播服务密码
          @param {Array} broadcastList   广播列表
              broadcastList {
                  @param {String} broadcastId     广播编号    NOT  NULL
                  @param {String} otherId         第三方编号  NOT  NULL
                  @param {String} broadcastIp     广播IP
                  @param {String} broadcastPort   广播端口
                  @param {String} broadcastUser   广播用户
                  @param {String} broadcastPsw    广播密码
              }
        * }
        */
  broadcastStart(reqBody) {
    return new Promise((resolve, reject) => {
      request("Broadcast.Start", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
       * @Description: 开始广播文件
       * {
          @param {String} broadcastServerId 广播服务编号 NOT  NULL
          @param {String} broadcastServerName 服务名称
          @param {String} otherServerId 服务第三方编号
          @param {String} broadcastServerBrand 广播服务品牌
          @param {String} broadcastServerIp 广播服务IP
          @param {String} broadcastServerPort 广播服务端口
          @param {String} broadcastServerUser 广播服务用户
          @param {String} broadcastServerPsw 广播服务密码
          @param {String} filePath        文件路径    NOT  NULL
          @param {Int}    duration        播放时长（秒）  NOT  NULL
          @param {Int}    playCount       播放次数    NOT  NULL
          @param {Array}  broadcastList   广播列表  广播实体数组
          broadcastList {
                  @param {String} broadcastId     广播编号    NOT  NULL
                  @param {String} otherId         第三方编号  NOT  NULL
                  @param {String} broadcastIp     广播IP
                  @param {String} broadcastPort   广播端口
                  @param {String} broadcastUser   广播用户
                  @param {String} broadcastPsw    广播密码
              }
        * }
        */
  broadcastFile(reqBody) {
    return new Promise((resolve, reject) => {
      request("BroadcastFile", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
       * @Description: 暂停广播
       * {
          @param {String} broadcastServerId 广播服务编号 NOT  NULL
          @param {String} broadcastServerName 服务名称
          @param {String} otherServerId 服务第三方编号
          @param {String} broadcastServerBrand 广播服务品牌
          @param {String} broadcastServerIp 广播服务IP
          @param {String} broadcastServerPort 广播服务端口
          @param {String} broadcastServerUser 广播服务用户
          @param {String} broadcastServerPsw 广播服务密码
          @param {Array} broadcastList   广播列表
              broadcastList {
                  @param {String} broadcastId     广播编号    NOT  NULL
                  @param {String} otherId         第三方编号  NOT  NULL
                  @param {String} broadcastIp     广播IP
                  @param {String} broadcastPort   广播端口
                  @param {String} broadcastUser   广播用户
                  @param {String} broadcastPsw    广播密码
              }
        * }
      * }
      */
  broadcastSuspend(reqBody) {
    return new Promise((resolve, reject) => {
      request("Broadcast.Suspend", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
       * @Description: 继续广播
       * {
          @param {String} broadcastServerId 广播服务编号 NOT  NULL
          @param {String} broadcastServerName 服务名称
          @param {String} otherServerId 服务第三方编号
          @param {String} broadcastServerBrand 广播服务品牌
          @param {String} broadcastServerIp 广播服务IP
          @param {String} broadcastServerPort 广播服务端口
          @param {String} broadcastServerUser 广播服务用户
          @param {String} broadcastServerPsw 广播服务密码
          @param {Array} broadcastList   广播列表
              broadcastList {
                  @param {String} broadcastId     广播编号    NOT  NULL
                  @param {String} otherId         第三方编号  NOT  NULL
                  @param {String} broadcastIp     广播IP
                  @param {String} broadcastPort   广播端口
                  @param {String} broadcastUser   广播用户
                  @param {String} broadcastPsw    广播密码
              }
        * }
      * }
      */
  broadcastPlayGoOn(reqBody) {
    return new Promise((resolve, reject) => {
      request("Broadcast.PlayGoOn", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
       * @Description: 停止广播
       * {
          @param {String} broadcastServerId 广播服务编号 NOT  NULL
          @param {String} broadcastServerName 服务名称
          @param {String} otherServerId 服务第三方编号
          @param {String} broadcastServerBrand 广播服务品牌
          @param {String} broadcastServerIp 广播服务IP
          @param {String} broadcastServerPort 广播服务端口
          @param {String} broadcastServerUser 广播服务用户
          @param {String} broadcastServerPsw 广播服务密码
          @param {Array} broadcastList   广播列表
              broadcastList {
                  @param {String} broadcastId     广播编号    NOT  NULL
                  @param {String} otherId         第三方编号  NOT  NULL
                  @param {String} broadcastIp     广播IP
                  @param {String} broadcastPort   广播端口
                  @param {String} broadcastUser   广播用户
                  @param {String} broadcastPsw    广播密码
              }
        * }
        * }
        */
  broadcastStop(reqBody) {
    return new Promise((resolve, reject) => {
      request("Broadcast.Stop", reqBody, {
        resolve,
        reject
      });
    });
  }
}
export default Broadcast;
